import { render, staticRenderFns } from "./TrackChangesLegend.vue?vue&type=template&id=198cdcbf&"
import script from "./TrackChangesLegend.vue?vue&type=script&lang=js&"
export * from "./TrackChangesLegend.vue?vue&type=script&lang=js&"
import style0 from "./TrackChangesLegend.vue?vue&type=style&index=0&id=198cdcbf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
